import { Carousel, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getHome } from "../services/api";
import { PopupBanner } from "./utils";

const POPUP_STORAGE_KEY = "homepage_popup_dismissed_this_tab";

const CarouselBanner = () => {
  const {
    data: images,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["home"],
    queryFn: async () => {
          const response = await getHome();
          return response;
        },
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[90vh]">
        <Spin size="large" />
      </div>
    );
  }

  if (isError || !images || !images.carousel || images.carousel.length === 0) {
    return <p className="text-center text-red-600">Failed to load banner</p>;
  }

  return (
    <>
      <Carousel
        arrows
        infinite
        autoplay
        autoplaySpeed={3000}
        dots
        effect="scrollx"
      >
        {images.carousel.map((src, idx) => (
          <div key={idx}>
            <img
              src={src}
              alt={`slide-${idx}`}
              style={{
                margin: 0,
                height: "90vh",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        ))}
      </Carousel>
      <PopupBanner popup={images?.banner} POPUP_STORAGE_KEY={POPUP_STORAGE_KEY} />
    </>
  );
};

export default CarouselBanner;
